const getUrlToken = () => window.location.pathname.split('/')[1] || '';

export default getUrlToken;
